import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Search from '../search/Search';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';

const AddMemberSearch = ({
    onBack,
    onChange,
    withSearch,
    searchPlaceholder,
    classes,
}) => {
    return (
        <Paper square elevation={1} className={classes.wrapper}>
            <IconButton
                className={classes.button}
                aria-label="Back"
                onClick={onBack}
            >
                <i className="material-icons">arrow_back</i>
            </IconButton>
            {withSearch && (
                <Search
                    value=""
                    onChange={onChange}
                    placeholder={searchPlaceholder}
                    showIcon={false}
                />
            )}
        </Paper>
    );
};

AddMemberSearch.propTypes = {
    onBack: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    withSearch: PropTypes.bool,
    searchPlaceholder: PropTypes.string.isRequired,
};

AddMemberSearch.defaultProps = {
    withSearch: true,
};

const style = ({ palette, spacing }) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginTop: spacing.unit * 3,
        color: palette.text.secondary,
    },
    button: {
        marginLeft: spacing.unit * 2,
        marginRight: spacing.unit,
    },
});

export default injectSheet(style)(AddMemberSearch);



// WEBPACK FOOTER //
// ./src/components/addMember/AddMemberSearch.js